<template>
  <div class="w-100 p-2" style="background: black;">
    <small class="text-light text-center d-block">Grupo Felix 2020 Todos los derechos reservados</small>
    <!-- Diseñado por Manuel de Noviembre -->
  </div>
</template>

<script>
export default {
  name: 'DarkFooter'
}
</script>

<style scoped>

</style>
